import axios, { AxiosInstance, AxiosResponse } from "axios";
import Cookies from 'js-cookie';
import { InjectionKey } from "vue";
import { IBasicUtil } from "./BasicUtil";

const TOKEN = "x34emvkdtaegeczksbetgdrfp29xtank"
const PASSWORD = "hK8#zzpg4mx6" // hk8#zzpg4mx6

export const DefaultHttpClient: InjectionKey<IHttpClient> = Symbol("api");
export interface IHttpClient {
  login: (data: IAuthRequest) => Promise<IAuthResponse>;
  get: (url: string) => Promise<any>
  auth: () => IAuthResponse;
  apiLogin: (data: IApiLoginRequest) => Promise<IApiLoginResponse|null>
  setLoading: (component: any, isFullScreen: boolean, isSetLoading: boolean) => IHttpClient
  postResult: (data: IResultRequest) => Promise<void>
  reset: () => Promise<void>
  getThumbnails: () => Promise<FileInfo[]>
  getBooks: (data: BookRequest) => Promise<FileInfo[]>
  sendContact: (data: IContactRequest) => Promise<IContactResponse>
}

export interface FileInfo {
  name: string;
  signedUrl: string;
  chapterNo: string;
  sectionNo: string;
}

export interface BookRequest {
  chapterNo: string;
  sectionNo: string;
}


export interface IAuthResponse {
  result: boolean,
  cookie: string
}

export interface IAuthRequest {
  userId: string
  password: string
}

export interface IContactRequest {
  name: string
  email: string
  body: string
  secret: string
}


export interface IApiLoginRequest {
  version: number
}

export interface IApiLoginResponse {
  chapterUrl: string
  sectionUrl: string
  questionUrl: string
  choiceUrl: string
  flashcardUrl: string
  latestVersion: number
  deleteIds: number[]
}

export interface IContactResponse {
  result: boolean
  error: string
}

export interface IResultRequest {
  id: number;
  isCorrect: boolean;
  allProgress: number;
  progress1: number;
  progress2: number;
  progress3: number;
  progress4: number;
}

export class HttpClient implements IHttpClient {
  public component: any = null
  public isFullScreen = true
  public isSetLoading = true
  private axiosInstance: AxiosInstance
  private basicUtil: IBasicUtil

  constructor(basicUtil: IBasicUtil) {
    this.basicUtil = basicUtil
    this.axiosInstance = this.getBasicInstance()
  }

  private getBasicInstance(): AxiosInstance {
    const axiosInstance = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      withCredentials: true,
    });
    axiosInstance.interceptors.request.use((request) => {
      this.basicUtil.showLoading()
      return request;
    });
    axiosInstance.interceptors.response.use(
      (response) => {
        this.basicUtil.hideLoading()
        return response;
      },
      (error) => {
        this.basicUtil.hideLoading()
        if (error.response.status == 401 && window.location.pathname != '/auth') {
          Cookies.remove("t-token")
          location.href = "/auth"
        }
        throw error;
      }
    );
    return axiosInstance
  }

  public setLoading(component: any, isFullScreen: boolean = false, isSetLoading: boolean = true) {
    this.component = component
    this.isFullScreen = isFullScreen
    this.isSetLoading = isSetLoading
    return this
  }

  private setAuthHeader() {
    this.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + Cookies.get("t-token");
  }

  public async get(url: string) {
    return axios.get(url).then((res: AxiosResponse<any>) => {
      return res.data
    }).catch((_) => {
      return null
    })
  }

  public auth() {
    const token = Cookies.get("t-token")
    if (process.env.NODE_ENV == 'development') {
      return {
        "cookie": String(TOKEN),
        "result": TOKEN === TOKEN
      }
    }
    return {
      "cookie": String(token),
      "result": TOKEN === token
    }
  }

  public async login(data: IAuthRequest) {
    data.password = data.password.replace('k', "K")
    return {
      "cookie": String(TOKEN),
      "result": PASSWORD === data.password
    }
  }

  public async apiLogin(data: IApiLoginRequest) {
    return this.axiosInstance.post<IApiLoginResponse>("auth/api-login/zyFSDHsr2tWuLWPVgkVSVqw2McriADnF", data).then((res: AxiosResponse<IApiLoginResponse>) => {
      return res.data
    }).catch((_) => {
      return null
    })
  }

  public async sendContact(data: IContactRequest) {
    return this.axiosInstance.post<IContactResponse>("auth/contact", data).then((res: AxiosResponse<IContactResponse>) => {
      return res.data
    }).catch((e) => {
      let errorMessage = ""
      if (e.response.data.errors["Name"]) {
        e.response.data.errors["Name"].forEach((r: string) => {
          errorMessage += r+ "<br>"
        })
      }
      if (e.response.data.errors["Email"]) {
        e.response.data.errors["Email"].forEach((r: string) => {
          errorMessage += r+ "<br>"
        })
      }
      if (e.response.data.errors["Body"]) {
        e.response.data.errors["Body"].forEach((r: string) => {
          errorMessage += r + "<br>"
        })
      }
      console.log(errorMessage)
      return {
        result: false,
        error: errorMessage
      }
    })
  }

  public async reset() {
    this.setAuthHeader()
    return this.axiosInstance.post("auth/reset", null).then((res: AxiosResponse<void>) => {
      return 
    }).catch((_) => {
      return 
    })
  }

  public async getThumbnails() {
    return this.axiosInstance.get("auth/get-book/g3BqXfNJ8SbkGRKFDUKJ38VDBGXtkAZ8").then((res: AxiosResponse<FileInfo[]>) => {
      return res.data
    }).catch((_) => {
      return []
    })
  }

  public async getBooks(data: BookRequest) {
    return this.axiosInstance.get("auth/get-books/g3BqXfNJ8SbkGRKFDUKJ38VDBGXtkAZ8", {
      params: {
        chapterNo: data.chapterNo,
        sectionNo: data.sectionNo
      }}).then((res: AxiosResponse<FileInfo[]>) => {
      return res.data
    }).catch((_) => {
      return []
    })
  }

  public async postResult(data: IResultRequest) {
    try {
      if (!navigator.onLine) return
      const axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        withCredentials: true,
      });
      axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + Cookies.get("t-token");
      axiosInstance.post("result", data).catch(_ => {
        
      })
    } catch {

    }
    
  }
}